import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuid4 } from "uuid";

const initialState = {
  code: uuid4()
};

const deviceDiscoverySlice = createSlice({
  name: "deviceDiscovery",
  initialState
});

export default deviceDiscoverySlice.reducer;
